
export const villaDescriptions = {
  villa1: [
    { name: "Холл", area: "22,86 м²" },
    { name: "Гардеробная", area: "8,05 м²" },
    { name: "Гостиная", area: "20,24 м²" },
    { name: "Кухня", area: "20,28 м²" },
    { name: "Спальня", area: "14,35 м²" },
    { name: "Ванная", area: "6,11 м²" },
    { name: "Холл", area: "10,33 м²" },
    { name: "Спальня", area: "14,35 м²" },
    { name: "Спальня", area: "20,28 м²" },
    { name: "Спальня", area: "20,24 м²" },
    { name: "Кабинет", area: "14,49 м²" },
    { name: "Ванная", area: "6,11 м²" },
    { name: "Балкон", area: "4,28 м²" },
    { name: "Общая площадь", area: "181,97 м²", total: true }
  ],
  villa2: [
    { name: "Прихожая", area: "8,17 м²" },
    { name: "Спальня", area: "12,60 м²" },
    { name: "Холл", area: "15,28 м²" },
    { name: "Спальня", area: "11,73 м²" },
    { name: "Ванная", area: "5,10 м²" },
    { name: "Кухня-Гостиная", area: "43,94 м²" },
    { name: "Холл", area: "18,01 м²" },
    { name: "Спальня", area: "11,73 м²" },
    { name: "Ванная", area: "5,10 м²" },
    { name: "Спальня", area: "17,18 м²" },
    { name: "Спальня", area: "14,79 м²" },
    { name: "Спальня", area: "12,60 м²" },
    { name: "Кабинет", area: "10,22 м²" },
    { name: "Общая площадь", area: "186,45 м²", total: true }
  ],
  villa3: [
    { name: "Прихожая", area: "7,40 м²" },
    { name: "Гардеробная", area: "7,52 м²" },
    { name: "Холл", area: "14,89 м²" },
    { name: "Спальня", area: "11,90 м²" },
    { name: "Ванная", area: "4,80 м²" },
    { name: "Кухня-Гостиная", area: "41,23 м²" },
    { name: "Холл", area: "8,96 м²" },
    { name: "Спальня", area: "11,90 м²" },
    { name: "Ванная", area: "4,80 м²" },
    { name: "Спальня", area: "16,79 м²" },
    { name: "Спальня", area: "23,59 м²" },
    { name: "Кабинет", area: "16,45 м²" },
    { name: "Балкон", area: "13,04 м²" },
    { name: "Общая площадь", area: "183,27 м²", total: true }
  ],
  villa4: [
    { name: "Прихожая", area: "6,58 м²" },
    { name: "Коридор", area: "8,30 м²" },
    { name: "Кухня", area: "18,09 м²" },
    { name: "Спальня", area: "13,22 м²" },
    { name: "Гостиная", area: "25,09 м²" },
    { name: "Ванная", area: "5,00 м²" },
    { name: "Терасса", area: "17,20 м²" },
    { name: "Коридор", area: "6,61 м²" },
    { name: "Спальня", area: "15,87 м²" },
    { name: "Кабинет", area: "9,46 м²" },
    { name: "Спальня", area: "14,04 м²" },
    { name: "Спальня", area: "14,50 м²" },
    { name: "Ванная", area: "5,00 м²" },
    { name: "Балкон", area: "5,61 м²" },
    { name: "Балкон", area: "14,49 м²" },
    { name: "Общая площадь", area: "179,06 м²", total: true }
  ],
  villa5: [
    { name: "Прихожая", area: "3,73 м²" },
    { name: "Холл", area: "13,49 м²" },
    { name: "Кухня", area: "23,52 м²" },
    { name: "Гостиная", area: "24,20 м²" },
    { name: "Спальня", area: "13,36 м²" },
    { name: "Спальня", area: "17,57 м²" },
    { name: "Душевая", area: "3,70 м²" },
    { name: "Ванная", area: "4,44 м²" },
    { name: "Ванная", area: "4,94 м²" },
    { name: "Холл", area: "20,19 м²" },
    { name: "Спальня", area: "14,80 м²" },
    { name: "Спальня", area: "18,34 м²" },
    { name: "Спальня", area: "14,70 м²" },
    { name: "Кабинет", area: "9,87 м²" },
    { name: "Общая площадь", area: "186,85 м²", total: true }
  ]
};
